module.exports = __webpack_public_path__ + "static/media/no-businesses.d2018cca.svg";